module.exports = __webpack_public_path__ + "s/img/5@2x.963d5b16.png";